import React from 'react';

export const ContactContext = React.createContext("");


// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/ShareMyRecord/context.js